// extracted by mini-css-extract-plugin
export default {"container":"SelectedProductsExceededPopup_container__IfCvj","subtitle":"SelectedProductsExceededPopup_subtitle__kq6C0"};